import { render, staticRenderFns } from "./AddCampus.vue?vue&type=template&id=673ceecc&scoped=true"
import script from "./AddCampus.vue?vue&type=script&lang=js"
export * from "./AddCampus.vue?vue&type=script&lang=js"
import style0 from "./AddCampus.vue?vue&type=style&index=0&id=673ceecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ceecc",
  null
  
)

export default component.exports